<mat-card class="mat-mdc-card mdc-card cardWithShadow card2 position-relative">
    <mat-card-content class="mat-mdc-card-content p-y-24">
      <section>
        <div class="col-md-4 navi">
          <ul>
            <li class="m-b-6">
              <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                <i-tabler name="download" class="routeIcon"></i-tabler>
              </button>
              <a (click)="DownloadSectorPrices(polywinSector)">
                {{ 'DownloadPolywinSectorPrices' | translate }}
              </a>
            </li>

            <li class="m-b-6">
              <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                <i-tabler name="download" class="routeIcon"></i-tabler>
              </button>
              <a (click)="DownloadAccessoriesPrices(polywinSector)">
                {{ 'DownloadPolywinAccessoriesPrices' | translate }}
              </a>
            </li>
            <li class="m-b-6">
              <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                <i-tabler name="download" class="routeIcon"></i-tabler>
              </button>
              <a (click)="DownloadSectorPrices(kemetwinSector)">
                {{ 'DownloadKemetwinSectorPrices' | translate }}
              </a>
            </li>

            <li class="m-b-6">
              <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
                <i-tabler name="download" class="routeIcon"></i-tabler>
              </button>
              <a (click)="DownloadAccessoriesPrices(kemetwinSector)">
                {{ 'DownloadKemetwinAccessoriesPrices' | translate }}
              </a>
            </li>
          </ul>
        </div>
      </section>
    </mat-card-content>
  </mat-card>
